/**
 * PIKA-780 — the few Timeline primitives that carry no app dependencies.
 *
 * `canvas_timeline_util` cannot be imported from a test: it reaches FeatureUtil,
 * which reaches util.js, directApi and the modal conductor, and the import dies
 * on a relay mutation. That is why `canvas_timeline.test.ts` is `describe.skip`.
 *
 * Anything a testable module needs from that file has to live somewhere free of
 * those imports. `canvas_timeline_util` re-exports everything here, so every
 * existing importer is unaffected and there is still one definition of each.
 */
import Moment from 'moment';

export const MIN_DATE_YEAR = 2000;

/** Canvas date 0. Everything else is a whole-day offset from it. */
export const getMinDate = () => Moment().year(MIN_DATE_YEAR).startOf('year');

export const getMomentFromCanvasTimelineDate = (canvasTimelineDate: number) =>
	getMinDate().add(Math.ceil(canvasTimelineDate), 'days');

export const ITEM_TYPE = {
	PROJECT_SCHEDULING_PROJECT: 0,
	PROJECT_SCHEDULING_PHASE: 1,
	TASK: 2,
	PROJECT_ALLOCATION: 5,
	PEOPLE_SCHEDULING_UNASSIGNED_TASK: 9,
	PEOPLE_SCHEDULING_UNASSIGNED_HEATMAP: 10,
	PROJECT_SCHEDULING_TEAM_ITEM: 13,
	PLACEHOLDER_ALLOCATION: 15,
	TIMELINE_GRAPH_ITEM: 17,
	HEATMAP_ITEM: 18,
};

/** Same test as `SchedulingUtils.isTaskItem`, without that module's import graph. */
export const isTaskItemType = (item: {itemType?: number}): boolean => item?.itemType === ITEM_TYPE.TASK;
